<template>
  <div class="main" style="min-height: 768px;">
    <section class="panel">
      <header class="panel-heading">
        <h2 class="panel-title">{{ pageTitle }}</h2>
      </header>
      <div class="panel-body container-fluid">
        <div class="row form-group">
          <div class="col-md-3 form-group">
            <label class="col-xs-4 col-md-5"><span class="text-danger">*</span>報修人學號</label>
            <div class="col-xs-8 col-md-7">
              <input type="text" class="form-control" :value="form.reporterAccount" disabled />
            </div>
          </div>
          <div class="col-md-3 form-group">
            <label class="col-xs-4 col-md-5"><span class="text-danger">*</span>報修人姓名</label>
            <div class="col-xs-8 col-md-7">
              <input type="text" class="form-control" :value="form.reporterName" disabled />
            </div>
          </div>
          <div class="col-md-3 form-group">
            <label class="col-xs-4 col-md-5"><span class="text-danger">*</span>電話</label>
            <div class="col-xs-8 col-md-7">
              <input v-model="form.reporterPhone" type="text" class="form-control" :disabled="!isCreate" />
            </div>
          </div>
          <div class="col-md-3 form-group">
            <label class="col-xs-4 col-md-5"><span class="text-danger">*</span>Email</label>
            <div class="col-xs-8 col-md-7">
              <input v-model="form.reporterEmail" type="text" class="form-control" :disabled="!isCreate" />
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-3 form-group">
            <label class="col-xs-4 col-md-5"><span class="text-danger">*</span>報修學期</label>
            <div class="col-xs-8 col-md-7">
              <select v-model="form.smtr" class="form-control" :disabled="!isCreate" @change="onSmtrChange">
                <option value="">--請選擇--</option>
                <option v-for="(item, index) in selectYear()" :key="'smtr-' + index" :value="item.value">{{ item.text }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3 form-group">
            <label class="col-xs-4 col-md-5"><span class="text-danger">*</span>報修項目</label>
            <div class="col-xs-8 col-md-7">
              <select v-model="form.repairItem" class="form-control" :disabled="!canEditRepairFields" @change="onRepairItemChange">
                <option value="">--請選擇--</option>
                <option v-for="(item, index) in repairItemList" :key="'item-' + index" :value="item">{{ item }}</option>
              </select>
            </div>
          </div>
          <div v-if="form.repairItem === '其他'" class="col-md-6 form-group">
            <label class="col-xs-4 col-md-2"><span class="text-danger">*</span>其他項目</label>
            <div class="col-xs-8 col-md-10">
              <input v-model="form.otherRepairItem" type="text" class="form-control" :disabled="!canEditRepairFields" maxlength="100" />
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-3 form-group">
            <label class="col-xs-4 col-md-5"><span class="text-danger">*</span>宿舍</label>
            <div class="col-xs-8 col-md-7">
              <select v-model="form.dormitoryName" class="form-control" :disabled="!canEditRepairFields" @change="onDormitoryChange">
                <option value="">--請選擇--</option>
                <option v-for="(item, index) in dormitoryList" :key="'dormitory-' + index" :value="item">{{ item }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3 form-group">
            <label class="col-xs-4 col-md-5"><span class="text-danger">*</span>樓層</label>
            <div class="col-xs-8 col-md-7">
              <select v-model="form.floorName" class="form-control" :disabled="!canEditRepairFields" @change="onFloorChange">
                <option value="">--請選擇--</option>
                <option v-for="(item, index) in floorOptions" :key="'floor-' + index" :value="item.floorName">{{ item.floorName }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3 form-group">
            <label class="col-xs-4 col-md-5"><span class="text-danger">*</span>報修地點</label>
            <div class="col-xs-8 col-md-7">
              <select v-model="selectedPlace" class="form-control" :disabled="!canEditRepairFields" @change="onPlaceChange">
                <option value="">--請選擇--</option>
                <option v-for="(item, index) in placeList" :key="'place-' + index" :value="item.value">{{ item.text }}</option>
              </select>
            </div>
          </div>
        </div>

        <div v-if="showRoomFields" class="row form-group">
          <div class="col-md-3 form-group">
            <label class="col-xs-4 col-md-5"><span class="text-danger">*</span>房號</label>
            <div class="col-xs-8 col-md-7">
              <select v-model="form.roomName" class="form-control" :disabled="!canEditRepairFields" @change="onRoomChange">
                <option value="">--請選擇--</option>
                <option v-for="(item, index) in roomOptions" :key="'room-' + index" :value="item.roomName">{{ item.roomName }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-9 form-group">
            <label class="col-xs-12 col-md-3"><span class="text-danger">*</span>房間內修繕時會在的人員名字</label>
            <div class="col-xs-12 col-md-9 repair-occupant-list">
              <label v-for="(item, index) in currentRoomOccupants" :key="'occupant-' + index" class="checkbox-inline repair-inline-checkbox">
                <input type="checkbox" :value="item" v-model="form.roomOccupants" :disabled="!canEditRepairFields" /> {{ item }}
              </label>
              <span v-if="!currentRoomOccupants.length" class="text-muted">查無房間入住名單</span>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label><span class="text-danger">*</span>可修繕時間</label>
            <div class="repair-time-grid">
              <div v-for="(day, dayIndex) in weekdayList" :key="'day-' + dayIndex" class="repair-time-row">
                <span class="repair-day-label">{{ day }}</span>
                <label v-for="(slot, slotIndex) in timeSlotList" :key="'slot-' + dayIndex + '-' + slotIndex" class="checkbox-inline repair-inline-checkbox">
                  <input
                    type="checkbox"
                    :value="buildTimeValue(day, slot)"
                    v-model="form.availableTimes"
                    :disabled="!isCreate"
                  />
                  {{ slot }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label><span class="text-danger">*</span>故障描述</label>
            <textarea v-model="form.description" class="form-control" rows="5" :disabled="!isCreate" maxlength="2000"></textarea>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-8 form-group">
            <label class="col-xs-4 col-md-3"><span class="text-danger">*</span>上傳照片</label>
            <div class="col-xs-8 col-md-9">
              <input v-if="isCreate" ref="photoFile" type="file" class="form-control" accept="image/*" @change="onPhotoChange" />
              <div v-else>
                <a v-if="form.photoDownloadUrl" href="javascript:;" @click="previewPhoto">{{ form.photoFileName }}</a>
                <span v-else class="text-muted">無附件</span>
              </div>
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">報修日期</label>
            <div class="col-xs-8 col-md-7">
              <input type="text" class="form-control" :value="form.crDateStr" disabled />
            </div>
          </div>
        </div>

        <div v-if="!isCreate" class="repair-divider"></div>

        <div v-if="!isCreate" class="row form-group">
          <div class="col-md-3 form-group">
            <label class="col-xs-4 col-md-5">維修廠商</label>
            <div class="col-xs-8 col-md-7">
              <input v-model="form.repairVendor" type="text" class="form-control" :disabled="!canReply" maxlength="100" />
            </div>
          </div>
          <div class="col-md-3 form-group">
            <label class="col-xs-4 col-md-5"><span class="text-danger">*</span>處理進度</label>
            <div class="col-xs-8 col-md-7">
              <select v-model="form.repairStatus" class="form-control" :disabled="!canReply">
                <option value="">--請選擇--</option>
                <option v-for="(item, index) in statusList" :key="'status-option-' + index" :value="item">{{ item }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3 form-group">
            <label class="col-xs-4 col-md-5">修繕日期</label>
            <div class="col-xs-8 col-md-7">
              <input v-model="form.repairProcessDate" type="datetime-local" class="form-control" :disabled="!canReply" />
            </div>
          </div>
        </div>

        <div v-if="!isCreate" class="row form-group">
          <div class="col-md-12">
            <label><span class="text-danger">*</span>修繕回覆說明</label>
            <textarea v-model="form.replyRemark" class="form-control" rows="5" :disabled="!canReply" maxlength="2000"></textarea>
          </div>
        </div>

        <div v-if="!isCreate" class="row form-group">
          <div class="col-md-12">
            <h4 class="repair-history-title">紀錄回覆歷程</h4>
            <table class="table table-no-more table-bordered table-striped mb-none">
              <thead>
                <tr>
                  <th class="text-center" width="8%">序號</th>
                  <th class="text-center" width="20%">回覆日期</th>
                  <th class="text-center" width="15%">處理進度</th>
                  <th class="text-center" width="17%">修繕日期</th>
                  <th class="text-center" width="15%">維修廠商</th>
                  <th class="text-center">修繕回覆說明</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!form.replyHistory.length">
                  <td class="text-center" colspan="6">尚無回覆紀錄</td>
                </tr>
                <tr v-for="(item, index) in form.replyHistory" :key="'history-' + index">
                  <td class="text-center" data-title="序號">{{ index + 1 }}</td>
                  <td class="text-center" data-title="回覆日期">{{ item.replyDateStr }}</td>
                  <td class="text-center" data-title="處理進度">{{ item.repairStatus }}</td>
                  <td class="text-center" data-title="修繕日期">{{ item.repairProcessDateStr || '-' }}</td>
                  <td class="text-center" data-title="維修廠商">{{ item.repairVendor || '-' }}</td>
                  <td data-title="修繕回覆說明">{{ item.replyRemark }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-offset-4 col-md-2 col-xs-6">
            <button type="button" class="btn btn-default btn-block" @click="goBack">返回</button>
          </div>
          <div v-if="isCreate || canReply" class="col-md-2 col-xs-6">
            <button type="button" class="btn btn-primary btn-block" @click="save">{{ isCreate ? '送出' : '儲存' }}</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* global bootbox */

const WEEKDAY_LIST = ["星期一", "星期二", "星期三", "星期四", "星期五"];
const TIME_SLOT_LIST = ["8-9", "9-10", "10-11", "11-12", "13-14", "14-15", "15-16", "16-17"];

function createDefaultForm() {
  return {
    id: "",
    smtr: "",
    reporterAccount: "",
    reporterName: "",
    reporterPhone: "",
    reporterEmail: "",
    repairItem: "",
    otherRepairItem: "",
    dormitoryName: "",
    floorName: "",
    placeType: "",
    placeName: "",
    roomName: "",
    roomOccupants: [],
    availableTimes: [],
    description: "",
    photoFile: null,
    photoFileName: "",
    photoDownloadUrl: "",
    repairVendor: "",
    repairStatus: "已收到",
    repairProcessDate: "",
    replyRemark: "",
    replyHistory: [],
    crDateStr: "",
  };
}

export default {
  data() {
    return {
      detailId: "",
      selectedPlace: "",
      form: createDefaultForm(),
      repairItemList: [],
      statusList: [],
      dormitoryList: [],
      floorList: [],
      roomList: [],
      placeList: [],
      defaultSmtr: "",
      weekdayList: WEEKDAY_LIST,
      timeSlotList: TIME_SLOT_LIST,
    };
  },
  computed: {
    isCreate() {
      return !this.detailId;
    },
    canCreate() {
      return this.sessionData && this.sessionData.isRoomMage === "Y" && !this.isAdmin("stay");
    },
    canReply() {
      return this.isAdmin("stay");
    },
    canEditRepairFields() {
      return this.isCreate || this.canReply;
    },
    pageTitle() {
      if (this.isCreate) {
        return "新增報修";
      }
      return this.canReply ? "報修回覆" : "報修明細";
    },
    floorOptions() {
      return this.floorList.filter((item) => item.dormitoryName === this.form.dormitoryName);
    },
    roomOptions() {
      return this.roomList.filter((item) => {
        const sameDormitory = !item.dormitoryName || item.dormitoryName === this.form.dormitoryName;
        return sameDormitory && item.floorName === this.form.floorName;
      });
    },
    currentRoomOccupants() {
      if (!this.canEditRepairFields && this.form.roomOccupants.length) {
        return this.form.roomOccupants;
      }
      for (let index = 0; index < this.roomOptions.length; index++) {
        if (this.roomOptions[index].roomName === this.form.roomName) {
          return this.roomOptions[index].occupants || [];
        }
      }
      return [];
    },
    showRoomFields() {
      if (this.canEditRepairFields) {
        return this.selectedPlace === "room";
      }
      return this.selectedPlace === "room" || this.form.placeType === "room";
    },
  },
  methods: {
    guardAccess() {
      if (this.canReply || this.canCreate) {
        return true;
      }
      bootbox.alert("無報修管理權限", () => {
        this.$router.replace({ name: "stay.list" });
      });
      return false;
    },
    selectYear() {
      let smtrArray = [];
      let nowYear = new Date().getFullYear() - 1911;
      let nowMonth = new Date().getMonth() + 1;
      if (nowMonth < 8) {
        nowYear = nowYear - 1;
      }
      for (let y = nowYear; y > 100; y--) {
        if ((y === nowYear && nowMonth < 8) || y < nowYear) {
          smtrArray.push({ text: y + "年第二學期", value: y + "2" });
        }
        smtrArray.push({ text: y + "年第一學期", value: y + "1" });
      }
      return smtrArray;
    },
    buildTimeValue(day, slot) {
      return day + " " + slot;
    },
    resolveDetailId() {
      const storeData = JSON.parse(this.getStore(this.$route.name));
      if (this.$route.query && this.$route.query.id) {
        return this.$route.query.id;
      }
      if (storeData && storeData.id) {
        return storeData.id;
      }
      return "";
    },
    loadInit(smtr = "") {
      const api = "/api/DormitoryRepair/init";
      const requestConfig = smtr ? { params: { smtr: smtr } } : {};
      this.$axios.get(api, requestConfig).then((resp) => {
        if (resp.data.status !== "success") {
          bootbox.alert(resp.data.msg || "取得報修初始化資料失敗", () => {
            this.$router.replace({ name: "stay.repair" });
          });
          return;
        }

        const initData = resp.data.data || {};
        this.repairItemList = initData.repairItemList || [];
        this.statusList = initData.statusList || [];
        this.dormitoryList = initData.dormitoryList || [];
        this.floorList = initData.floorList || [];
        this.roomList = initData.roomList || [];
        this.placeList = initData.placeList || [];
        this.defaultSmtr = initData.defaultSmtr || "";

        if (this.isCreate) {
          this.form.smtr = this.defaultSmtr || this.form.smtr;
          this.form.reporterAccount = initData.reporterAccount || "";
          this.form.reporterName = initData.reporterName || "";
          this.form.reporterPhone = initData.reporterPhone || "";
          this.form.reporterEmail = initData.reporterEmail || "";

          if (this.dormitoryList.indexOf(this.form.dormitoryName) === -1) {
            this.form.dormitoryName = initData.defaultDormitoryName || "";
          }

          const hasMatchedFloor = this.floorList.some((item) => {
            return item.dormitoryName === this.form.dormitoryName && item.floorName === this.form.floorName;
          });
          if (!hasMatchedFloor) {
            this.form.floorName = initData.defaultFloorName || "";
          }

          const hasMatchedRoom = this.roomList.some((item) => {
            return item.dormitoryName === this.form.dormitoryName
              && item.floorName === this.form.floorName
              && item.roomName === this.form.roomName;
          });
          if (!hasMatchedRoom) {
            this.form.roomName = "";
            this.form.roomOccupants = [];
          }
        }

        if (this.detailId) {
          this.loadDetail(this.detailId);
          return;
        }

        if (!this.canCreate) {
          bootbox.alert("僅舍長可新增報修", () => {
            this.$router.replace({ name: "stay.repair" });
          });
        }
      });
    },
    loadDetail(id) {
      const api = "/api/DormitoryRepair/detail/" + id;
      this.$axios.get(api).then((resp) => {
        if (resp.data.status !== "success") {
          bootbox.alert(resp.data.msg || "查無報修資料", () => {
            this.$router.replace({ name: "stay.repair" });
          });
          return;
        }

        const detail = resp.data.data || {};
        this.form = Object.assign(createDefaultForm(), {
          id: detail.id || "",
          smtr: detail.smtr || "",
          reporterAccount: detail.reporterAccount || "",
          reporterName: detail.reporterName || "",
          reporterPhone: detail.reporterPhone || "",
          reporterEmail: detail.reporterEmail || "",
          repairItem: detail.repairItem || "",
          otherRepairItem: detail.otherRepairItem || "",
          dormitoryName: detail.dormitoryName || "",
          floorName: detail.floorName || "",
          placeType: detail.placeType || "",
          placeName: detail.placeName || "",
          roomName: detail.roomName || "",
          roomOccupants: detail.roomOccupants || [],
          availableTimes: detail.availableTimes || [],
          description: detail.description || "",
          photoFile: null,
          photoFileName: detail.photoFileName || "",
          photoDownloadUrl: detail.photoDownloadUrl || "",
          repairVendor: detail.repairVendor || "",
          repairStatus: detail.repairStatus || "",
          repairProcessDate: this.toDateTimeLocal(detail.repairProcessDate),
          replyRemark: detail.lastReplyRemark || "",
          replyHistory: detail.replyHistory || [],
          crDateStr: detail.crDateStr || "",
        });
        this.syncSelectedPlace();
        this.syncRoomOccupants();
      });
    },
    syncSelectedPlace() {
      if (this.form.placeType === "room") {
        this.selectedPlace = "room";
        return;
      }

      for (let index = 0; index < this.placeList.length; index++) {
        if (this.placeList[index].text === this.form.placeName) {
          this.selectedPlace = this.placeList[index].value;
          return;
        }
      }
      this.selectedPlace = "";
    },
    syncRoomOccupants() {
      if (!this.canEditRepairFields) {
        return;
      }
      const validOccupants = [];
      const currentOccupants = this.currentRoomOccupants;
      for (let index = 0; index < this.form.roomOccupants.length; index++) {
        if (currentOccupants.indexOf(this.form.roomOccupants[index]) > -1) {
          validOccupants.push(this.form.roomOccupants[index]);
        }
      }
      this.form.roomOccupants = validOccupants;
    },
    onRepairItemChange() {
      if (this.form.repairItem !== "其他") {
        this.form.otherRepairItem = "";
      }
    },
    onSmtrChange() {
      this.form.dormitoryName = "";
      this.form.floorName = "";
      this.form.roomName = "";
      this.form.roomOccupants = [];
      this.loadInit(this.form.smtr);
    },
    onDormitoryChange() {
      let floorMatched = false;
      for (let index = 0; index < this.floorOptions.length; index++) {
        if (this.floorOptions[index].floorName === this.form.floorName) {
          floorMatched = true;
          break;
        }
      }
      if (!floorMatched) {
        this.form.floorName = "";
      }
      this.form.roomName = "";
      this.form.roomOccupants = [];
    },
    onFloorChange() {
      let roomMatched = false;
      for (let index = 0; index < this.roomOptions.length; index++) {
        if (this.roomOptions[index].roomName === this.form.roomName) {
          roomMatched = true;
          break;
        }
      }
      if (!roomMatched) {
        this.form.roomName = "";
      }
      this.syncRoomOccupants();
    },
    onPlaceChange() {
      if (this.selectedPlace !== "room") {
        this.form.roomName = "";
        this.form.roomOccupants = [];
      }
    },
    onRoomChange() {
      this.syncRoomOccupants();
    },
    onPhotoChange(event) {
      const files = event.target.files || [];
      this.form.photoFile = files.length > 0 ? files[0] : null;
    },
    async previewPhoto() {
      if (!this.form.photoDownloadUrl) {
        return;
      }

      try {
        const resp = await this.$axios.get(this.form.photoDownloadUrl, {
          responseType: "blob",
        });

        const contentType = ((resp.headers && resp.headers["content-type"]) || "").toLowerCase();
        if (contentType.indexOf("application/json") > -1) {
          const message = await this.getBlobMessage(resp.data, "預覽照片失敗");
          bootbox.alert(message);
          return;
        }

        const blobUrl = window.URL.createObjectURL(resp.data);
        window.open(blobUrl, "_blank");
        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl);
        }, 1000);
      } catch (error) {
        const fallback = "預覽照片失敗";
        if (error && error.response && error.response.data) {
          const message = await this.getBlobMessage(error.response.data, fallback);
          bootbox.alert(message);
          return;
        }
        bootbox.alert(fallback);
      }
    },
    async getBlobMessage(blob, fallbackMessage) {
      try {
        const text = await blob.text();
        const json = JSON.parse(text);
        return json.msg || fallbackMessage;
      } catch (error) {
        return fallbackMessage;
      }
    },
    toDateTimeLocal(value) {
      if (!value) {
        return "";
      }
      const targetDate = new Date(value);
      if (isNaN(targetDate.getTime())) {
        return "";
      }
      const year = targetDate.getFullYear();
      const month = ("0" + (targetDate.getMonth() + 1)).slice(-2);
      const day = ("0" + targetDate.getDate()).slice(-2);
      const hour = ("0" + targetDate.getHours()).slice(-2);
      const minute = ("0" + targetDate.getMinutes()).slice(-2);
      return year + "-" + month + "-" + day + "T" + hour + ":" + minute;
    },
    getSelectedPlaceText() {
      for (let index = 0; index < this.placeList.length; index++) {
        if (this.placeList[index].value === this.selectedPlace) {
          return this.placeList[index].text;
        }
      }
      return "";
    },
    createPayload() {
      return {
        smtr: this.form.smtr,
        phone: this.form.reporterPhone,
        email: this.form.reporterEmail,
        repairItem: this.form.repairItem,
        otherRepairItem: this.form.otherRepairItem,
        dormitoryName: this.form.dormitoryName,
        floorName: this.form.floorName,
        placeType: this.selectedPlace === "room" ? "room" : "public",
        placeName: this.selectedPlace === "room" ? "房間" : this.getSelectedPlaceText(),
        roomName: this.selectedPlace === "room" ? this.form.roomName : "",
        roomOccupants: this.selectedPlace === "room" ? this.form.roomOccupants : [],
        availableTimes: this.form.availableTimes,
        description: this.form.description,
      };
    },
    saveCreate() {
      const formData = new FormData();
      formData.append("repairData", JSON.stringify(this.createPayload()));
      if (this.form.photoFile) {
        formData.append("photoFile", this.form.photoFile);
      }

      const api = "/api/DormitoryRepair/create";
      this.$axios.post(api, formData).then((resp) => {
        if (resp.data.status !== "success") {
          bootbox.alert(resp.data.msg || "新增報修失敗");
          return;
        }

        const result = resp.data.data || {};
        this.detailId = result.id || "";
        if (this.detailId) {
          this.setStore("stay.repair.edit", { id: this.detailId });
          this.$router.replace({ name: "stay.repair.edit", query: { id: this.detailId } });
          this.loadDetail(this.detailId);
          return;
        }

        bootbox.alert("報修已送出", () => {
          this.$router.replace({ name: "stay.repair" });
        });
      });
    },
    saveReply() {
      const api = "/api/DormitoryRepair/reply";
      this.$axios.post(api, JSON.stringify({
        id: this.form.id,
        repairItem: this.form.repairItem,
        otherRepairItem: this.form.otherRepairItem,
        dormitoryName: this.form.dormitoryName,
        floorName: this.form.floorName,
        placeType: this.selectedPlace === "room" ? "room" : "public",
        placeName: this.selectedPlace === "room" ? "房間" : this.getSelectedPlaceText(),
        roomName: this.selectedPlace === "room" ? this.form.roomName : "",
        roomOccupants: this.selectedPlace === "room" ? this.form.roomOccupants : [],
        repairVendor: this.form.repairVendor,
        repairStatus: this.form.repairStatus,
        repairProcessDate: this.form.repairProcessDate || null,
        replyRemark: this.form.replyRemark,
      })).then((resp) => {
        if (resp.data.status !== "success") {
          bootbox.alert(resp.data.msg || "儲存報修回覆失敗");
          return;
        }

        bootbox.alert("報修回覆已儲存", () => {
          this.loadDetail(this.form.id);
        });
      });
    },
    save() {
      if (this.isCreate) {
        this.saveCreate();
        return;
      }
      this.saveReply();
    },
    goBack() {
      this.$router.push({ name: "stay.repair" });
    },
  },
  mounted() {
    if (!this.guardAccess()) {
      return;
    }

    this.detailId = this.resolveDetailId();
    if (!this.detailId && !this.canCreate) {
      bootbox.alert("僅舍長可新增報修", () => {
        this.$router.replace({ name: "stay.repair" });
      });
      return;
    }

    this.loadInit();
  },
};
</script>

<style scoped>
.repair-time-grid {
  margin-top: 8px;
}

.repair-time-row {
  margin-bottom: 8px;
}

.repair-day-label {
  display: inline-block;
  min-width: 60px;
  font-weight: 600;
}

.repair-inline-checkbox {
  margin-right: 12px;
  margin-bottom: 6px;
}

.repair-occupant-list {
  padding-top: 6px;
}

.repair-divider {
  border-top: 1px solid #ddd;
  margin: 16px 0;
}

.repair-history-title {
  margin-top: 0;
  margin-bottom: 12px;
  font-weight: 600;
}
</style>
